// VIBRANIAM-SPACE v2 - useIsMobile.js
// Layout-based mobile detection (CSS media query on viewport width), not user
// agent sniffing: a touch laptop or a resized desktop window gets the same
// treatment as an actual phone, which is what the layout switch is meant to
// track anyway.

import { useEffect, useState } from 'react';

const QUERY = '(max-width: 768px)';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

export default useIsMobile;
